import axios from "axios";
import { ip } from "./config";

/**
 * 
 * @param {*} code 
 * data.platform -mini plus mall
 * data.query -链接中的传参{id:1}
 * data.path -链接路径
 * @returns 
 */
export async function createLink(data) {
  var resp = await axios.post(`${ip}/zskx/h5/wxLink/createLink`, data);
  return resp.data;
}
